module.exports = __webpack_public_path__ + "img/telecmi.ad11c482.svg";